'use strict';
window.uomedia = window.uomedia || {};

(($) => {
  $(window).load(function() {
    const Plyr = window.Plyr || {};
    const $homeCarousel = $('.homepage-carousel');

    if($('.plyr-video').length) {
      // initialize all plyr videos on the page
      const players = Array.from(document.querySelectorAll('.plyr-video')).map((p) => new Plyr(p));

      // attach click event for each button to play its corresponding plyr video
      $('.video-player button.play').each(function(i) {
        const $this = $(this);

        $this.on('click', function() {
          const $videoContainer = $this.siblings('.video');

          $this.hide().siblings('.thumb-container').addClass('hide');
          $videoContainer.addClass('show');
          players[i].play();
        });
      });

      // if homepage carousel, stop plyr videos on slide change
      if($homeCarousel.length) {
        $homeCarousel.on('beforeChange', function() {
          players.forEach(function(player) {
            player.pause();
          });
        });
      }
    }
  });
})(jQuery);
